export const addLinkTarget = (arr) => {
  const parts = arr.split(/(<a\s+[^>]*href\s*=\s*"[^"]*"[^>]*>)/gi)

  const modifiedParts = parts.map((part) => {
    // Check if the part includes an href attribute
    if (part.includes('href="')) {
      const modifiedPart = part.replace(
        /href\s*=\s*"([^"]*)"/i,
        (match, p1) => {
          // Check if the href value does not include 'sxmsir.com'
          // eslint-disable-next-line no-undef
          if (!p1.includes(process.env.NEXT_PUBLIC_DOMAIN_URL)) {
            // Add target="_blank" to the href attribute
            return `href="${p1}" target="_blank"`
          }
          // Return the original href attribute if it includes 'sxmsir.com'
          return match
        }
      )

      return modifiedPart
    }

    // Return the original part if it doesn't include an href attribute
    return part
  })

  const modifiedArr = modifiedParts.join('')

  return modifiedArr
}
